import { Button, Col, DatePicker, Form, Grid, Input, Modal, Row, Space, Table, Tabs } from "antd";
import type { IConvenente, IConvenio, ICtrlDoc, IDocumento, ISelectList } from "../../../components/Interfaces";
import { CloseOutlined, EyeOutlined } from "@ant-design/icons";
import { useEffect, useState, type Dispatch, type SetStateAction } from "react";
import dayjs from "dayjs";
import { apiConvenio } from "../../../services/api";
import { errorMessage } from "../../../messages/messages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIdCard } from "@fortawesome/free-solid-svg-icons";
import { getDocPdf } from "../../../services/apiDocumentos";
import { maskCnpj } from "../../../utils/maskFunctions";
import { formatarData } from "../../../utils/utilsFunctions";
import FormModalDocumento from "../../../components/FormModalDocumento";
import { carregaListaDocumento } from "../../PessoaJuridica/services";

const { useBreakpoint } = Grid;

interface IProps {
  serieConvenio: number;
  setLoading: Dispatch<SetStateAction<boolean>>;
  setTipLoading: Dispatch<SetStateAction<string>>;
  manter: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
}

const ConvenioAdesao = ({ serieConvenio, setLoading, setTipLoading, manter }: IProps) => {
  const [form] = Form.useForm();
  const [convenentes, setConvenentes] = useState<IConvenente[]>([]);
  const [documentos, setDocumentos] = useState<IDocumento[]>([]);

  const [listDocumentoConvenio, setListDocumentoConvenio] = useState<ISelectList[]>([]);
  const [ctrlDocConvenio, setCtrlDocConvenio] = useState<ICtrlDoc[]>([]);

  const detalharConvenio = async (serieConvenio: number) => {
    setTipLoading("Carregando dados...");
    setLoading(true);

    let lQuery = `/ultimo/${serieConvenio}/serie`;
    await apiConvenio.get<IConvenio>(lQuery).then((response) => {
      const convenio = response.data;
      console.log(convenio);
      form.setFieldsValue({
        serie: convenio.serie,
        numeroProcesso: convenio.numeroProcesso,
        tipoConvenio: convenio.tipoConvenio,
        dataInicioVigencia: dayjs(convenio.dataInicioVigencia),
        dataAutorizacao: dayjs(convenio.dataAutorizacao),
        dataVigencia: dayjs(convenio.dataVigencia),
        possuiSolidariedade: convenio.possuiSolidariedade,
        codigoModelo: convenio.codigoModelo,
        preveInscricaoAutomatica: convenio.preveInscricaoAutomatica,
      })

      setConvenentes(convenio.convenentes);
      setDocumentos(convenio.documentos);
    }).catch((error) => {
      errorMessage(error);
    });
    setLoading(false);
  }

  const carregaListaDocumentoConvenioOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("8388608").then((response) => {
      if (response.data.length === 0) {
        errorMessage("Não foi possível recuperar os tipos de documentos de convênio de adesão");
      } else {
        setCtrlDocConvenio(response.data);
        response.data.forEach((p: ICtrlDoc) => {
          listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
        });
      }
    });
    setListDocumentoConvenio(listaLocal);
  }


  useEffect(() => {
    detalharConvenio(serieConvenio);

    const carregaDadosIniciais = async () => {
      carregaListaDocumentoConvenioOpcoes();
    }
    carregaDadosIniciais();

  }, []);



  const colunasConvenentes = [
    {
      key: "1",
      title: "CNPJ",
      render: (convenente: IConvenente) => (
        <div>
          {maskCnpj(convenente?.numeroPessoaJuridica)}
        </div>
      ),
    },
    {
      key: "2",
      title: "Razão Social",
      render: (convenente: IConvenente) => (
        <div>
          {convenente.pessoaJuridica?.razaoSocial}
        </div>
      ),
    },
    // {
    //   key: "3",
    //   title: "Quantidade de pessoas abaixo do teto",
    //   render: (convenente: IConvenente) => (
    //     <div>
    //       {convenente.qtdePessoaAbaixoTeto}
    //     </div>
    //   ),
    // },
    // {
    //   key: "4",
    //   title: "Idade média abaixo do teto",
    //   render: (convenente: IConvenente) => (
    //     <div>
    //       {convenente.idadeMediaAbaixoTeto}
    //     </div>
    //   ),
    // },
    // {
    //   key: "5",
    //   title: "Remuneração média abaixo do teto",
    //   render: (convenente: IConvenente) => (
    //     <div>
    //       {convenente.remuneracaoMediaAbaixoTeto}
    //     </div>
    //   ),
    // },
    // {
    //   key: "6",
    //   title: "Quantidade de pessoas acima do teto",
    //   render: (convenente: IConvenente) => (
    //     <div>
    //       {convenente.qtdePessoaAcimaTeto}
    //     </div>
    //   ),
    // },
    // {
    //   key: "7",
    //   title: "Idade média acima do teto",
    //   render: (convenente: IConvenente) => (
    //     <div>
    //       {convenente.idadeMediaAcimaTeto}
    //     </div>
    //   ),
    // },
    // {
    //   key: "8",
    //   title: "Remuneração média acima do teto",
    //   render: (convenente: IConvenente) => (
    //     <div>
    //       {convenente.remuneracaoMediaAcimaTeto}
    //     </div>
    //   ),
    // },
  ];

  const colunasDocumentos = [
    {
      key: "1",
      title: "Número",
      render: (doc: IDocumento) => (
        <div>
          {doc.nuDocumento}
        </div>
      ),
    },
    {
      key: "2",
      title: "Nome",
      render: (doc: IDocumento) => (
        <div>
          {doc.nmDocumento}
        </div>
      ),
    },
    {
      key: "3",
      title: "Tipo",
      render: (doc: IDocumento) => (
        <div>
          {doc.idCtrlDocTpDoc}
        </div>
      ),
    },
    {
      key: "4",
      title: "Data",
      render: (doc: IDocumento) => (
        <div>
          {formatarData(doc.dtDocumento)}
        </div>
      ),
    },
    {
      key: "5",
      title: "Arquivo",
      render: (doc: IDocumento) => (
        <div>
          <Button
            id="arquivo"
            shape="round"
            icon={<EyeOutlined />}
            htmlType="button"
            onClick={() => {
              getDocPdf(doc.idDocumento!);
            }}
          />
        </div>
      ),
    },
  ];

  const abas = [
    {
      key: '1',
      label: 'Convenentes',
      icon: <FontAwesomeIcon icon={faIdCard} />,
      children:
        <>
          <Table size="small" rowKey="id" columns={colunasConvenentes} dataSource={convenentes} />
        </>
    },
    {
      key: '2',
      label: 'Documentos',
      icon: <FontAwesomeIcon icon={faIdCard} />,
      children:
        <FormModalDocumento
          ctrlDoc={ctrlDocConvenio}
          objetoDocumento={documentos}
          setObjetoDocumento={setDocumentos}
          listaDocumentos={listDocumentoConvenio}
          manter={manter}
        />

      // <Table size="small" rowKey="idDocumento" columns={colunasDocumentos} dataSource={documentos} />
    },
  ];

  return (
    <>
      <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >
        <Row>
          <Col xs={24} md={12} xl={12}>
            <Form.Item label="Série"
              labelAlign="left"
              labelCol={{ span: 20 }}
              name="serie"
              colon={false}
            >
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} xl={12}>
            <Form.Item label="Número do processo"
              labelAlign="left"
              labelCol={{ span: 20 }}
              name="numeroProcesso"
              colon={false}
            >
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12} xl={12}>
            <Form.Item label="Tipo"
              labelAlign="left"
              labelCol={{ span: 20 }}
              name="tipoConvenio"
              colon={false}
            >
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} xl={12}>
            <Form.Item label="Data de autorização"
              labelAlign="left"
              labelCol={{ span: 20 }}
              name="dataAutorizacao"
              colon={false}
            >
              <DatePicker
                format={"DD/MM/YYYY"}
                style={{ width: "100%" }}
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12} xl={12}>
            <Form.Item label="Data de vigência"
              labelAlign="left"
              labelCol={{ span: 20 }}
              name="dataVigencia"
              colon={false}
            >
              <DatePicker
                format={"DD/MM/YYYY"}
                style={{ width: "100%" }}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} xl={12}>
            <Form.Item label="Data de início da vigência"
              labelAlign="left"
              labelCol={{ span: 20 }}
              name="dataInicioVigencia"
              colon={false}
            >
              <DatePicker
                format={"DD/MM/YYYY"}
                style={{ width: "100%" }}
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12} xl={12}>
            <Form.Item label="Possui solidariedade"
              labelAlign="left"
              labelCol={{ span: 20 }}
              name="possuiSolidariedade"
              colon={false}
            >
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} xl={12}>
            <Form.Item label="Código do modelo"
              labelAlign="left"
              labelCol={{ span: 20 }}
              name="codigoModelo"
              colon={false}
            >
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12} xl={12}>
            <Form.Item label="Prevê inscrição automática"
              labelAlign="left"
              labelCol={{ span: 20 }}
              name="preveInscricaoAutomatica"
              colon={false}
            >
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Tabs
            defaultActiveKey="1"
            items={abas}
          />
        </Row>
      </Form>
    </>
  );
}

export default ConvenioAdesao;
